import {
    apiRequest,
    detailperioderevisikeuangan
} from "../../../../../services/adapters/kepegawaian/revisikeuanganService"

class IndexRepository {


    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", detailperioderevisikeuangan, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default IndexRepository;